export default __webpack_public_path__ + "static/media/left_arrow.2364ebb8.svg";